export const NAV_ITEMS = [
  { label: 'PROYECTOS', href: '#proyectos' },
  { label: 'SERVICIOS', href: '#servicios' },
  { label: 'PROCESO', href: '#metodologia' },
  { label: 'CONTACTO', href: '#contacto' }
];
